export class GenericGraphQlError<R = unknown> extends Error {
  constructor(public data?: R) {
    super();
  }
}
